<template>
<div>
  <form class="ui form" @submit.prevent="search()" :class="{'loading': loadForm.waiting}">
    <h4 class="ui dividing header">検索条件</h4>
    <div class="fields">
      <div class="field">
        <label>ステータス</label>
        <dropdown v-model="searchForm.model.is_public" @change="search()">
          <option value="true">公開</option>
          <option value="false">非公開</option>
        </dropdown>
      </div>
      <div class="field">
        <label>ランク</label>
        <dropdown v-model="searchForm.model.rank" @change="search()" :options="consts.SHOP_RANK" :placeholder="'すべて'">
          <option value="">すべて</option>
        </dropdown>
      </div>
      <div class="four wide field">
        <label>グループ</label>
        <dropdown v-model="searchForm.model.group_id" @change="search()" :placeholder="'すべて'">
          <option value="">すべて</option>
          <option value="-1">無所属</option>
          <option v-for="group in groups" :key="group.id" :value="group.id">{{ group.name }} ({{ group.shops.length }}件)</option>
        </dropdown>
      </div>
      <div class="field">
        <label>都道府県</label>
        <dropdown v-model="searchForm.model.prefecture" @change="onPrefectureChange()" :placeholder="'すべて'">
          <option value="">すべて</option>
          <option v-for="each in consts.SHOP_PREFECTURE" :key="each.label" :value="each.value" :disabled="each.value === ''">
            {{ each.label }}
          </option>
        </dropdown>
      </div>
      <div class="field">
        <label>エリア</label>
        <dropdown v-model="searchForm.model.area" @change="search()" :placeholder="'すべて'">
          <option value="">すべて</option>
          <option v-for="each in areaOptions" :key="each.label" :value="each.value" :disabled="each.value === ''">
          {{ each.label }}
          </option>
        </dropdown>
      </div>
    </div>
    <div class="fields">
      <div class="field">
        <label>最大立食人数</label>
        <dropdown v-model="searchForm.model.max_standing_count_from" @change="search()" :placeholder="'指定しない'">
          <option value="">指定しない</option>
          <option v-for="each in [20, 30, 40, 50, 60, 70, 80, 90, 100, 200, 300, 500]" :value="each">{{ each }}人</option>
        </dropdown>
      </div>
      <div class="field">
        <label>&nbsp;</label>
        <span style="display: inline-block; margin-top: 50%;">〜</span>
      </div>
      <div class="field">
        <label>&nbsp;</label>
        <dropdown v-model="searchForm.model.max_standing_count_to" @change="search()" :placeholder="'指定しない'">
          <option value="">指定しない</option>
          <option v-for="each in [20, 30, 40, 50, 60, 70, 80, 90, 100, 200, 300, 500]" :value="each">{{ each }}人</option>
        </dropdown>
      </div>
      <div class="six wide field">
        <label>店舗ID / 店舗名 / TEL / メールアドレス / 企業名</label>
        <div class="ui action input">
          <input v-model="searchForm.model.q" type="text" placeholder="検索条件">
          <button class="ui teal button">Search</button>
        </div>
      </div>
    </div>
  </form>

  <div class="search-result" :class="{'loading': searchForm.waiting}">
    <div class="ui vertical top loader" :class="{'active': searchForm.waiting}"></div>
    <div class="ui horizontal divider header">検索結果</div>
    <div class="relative">
      <pagination :pager="pager" :callback="search"></pagination>
      <div style="display: inline-block; position: absolute; right: 0; bottom: 0;">
        <a href="/afadmin/shops/new">
          <button type="button" class="ui small positive button"><i class="plus icon"></i>新規登録</button>
        </a>
      </div>
    </div>
    <table class="ui compact selectable table">
      <thead>
        <tr>
          <th class="shop-id">店舗ID</th>
          <th class="rank center aligned">ランク</th>
          <th>手数料率</th>
          <th>店舗名</th>
          <th>TEL</th>
          <th>グループ</th>
          <th>企業名</th>
          <th class="actions actions--wide">&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="shop in shops" :key="shop.id">
          <td class="shop-id">{{ shop.id }}</td>
          <td class="rank">{{ shop.rank_label }}</td>
          <td>{{ shop.charge_rate }}%</td>
          <td>
            <a :href="shop.shop_preview_url" target="_blank">{{ shop.name }}</a>
            <a v-if="isStaff" :href="shop.auth_url" target="_blank"><i class="sign in icon"></i></a>
          </td>
          <td>{{ shop.tel }}</td>
          <td>{{ shop.group_name }}</td>
          <td>{{ shop.company_name }}</td>
          <td class="actions">
            <a :href="shop.edit_url"><button type="button" class="ui inverted tiny positive basic button">編集</button></a>
            <button v-if="isStaff" @click="remove(shop)" type="button" class="ui inverted tiny negative basic button">削除</button>
            <button @click="copy(shop)" type="button" class="ui tiny button">コピー</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
</template>

<script>

export default {
    data: function() {
        return {
            areaDetailOptions: [],
            loadForm: this.createForm(),
            searchForm: this.createForm(_.defaults(this.query(), {
                is_public: true,
                group: '',
                rank: '',
            })),
            pager: this.createPager(15, this.query().offset),
            shops: [],
            groups: [],
            areaOptions: [],
            areas: [],
        };
    },
    created: function() {
        this.loadForm.get('/afadmin/api/groups', function(response) {
            this.groups = response.data;
        }.bind(this));
        this.createForm().get('/api/areas/', function(response) {
            _.forEach(response.data, function(each) {
                this.areas.push(each);
            }.bind(this));
            const selectedPrefecture = this.searchForm.model.prefecture;
            this.areaOptions = this.areas.filter(area => area.prefecture === selectedPrefecture);
        });
        this.search(this.pager.current());
    },
    methods: {
        remove: function(shop) {
            if (!confirm('この操作は元に戻せません。実行してもよろしいですか？')) {
                return;
            }
            this.createForm().delete(shop.detail_api_url, function() {
                this.search(this.pager.current()).then(function() {
                    this.modalEl.modal('hide');
                }.bind(this));
            }.bind(this));
        },
        copy: function(shop) {
            this.createForm().post(shop.copy_api_url, function(response) {
                window.location.href = response.data.edit_url;
            }.bind(this));
        },
        search: function(opt_position) {
            var position = opt_position || this.pager.first();
            this.merge(this.searchForm.model, position);
            this.replaceStateQuery(this.searchForm.model, ['limit']);
            return this.searchForm.get('/afadmin/api/shops', function(response) {
                this.shops = response.data;
                this.pager.update(response.data, response);
            }.bind(this));
        },
        onPrefectureChange: function() {
            const selectedPrefecture = this.searchForm.model.prefecture;
            if (selectedPrefecture === '') {
                this.searchForm.model.area = null;
                this.areaOptions = [];
            } else {
                this.areaOptions = this.areas.filter(area => area.prefecture === selectedPrefecture);
                if (this.areaOptions.length > 0) {
                    this.searchForm.model.area = null;
                }
            }
            this.search();
        },
    }
};
</script>
